import { render, staticRenderFns } from "./SimpleModuleComponent.vue?vue&type=template&id=79b01541"
import script from "./SimpleModuleComponent.vue?vue&type=script&lang=js"
export * from "./SimpleModuleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports